/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRank8 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10.14 8.798c-.44.34-.66.817-.66 1.43 0 .434.153.81.46 1.13.154.161.346.303.576.427a2.04 2.04 0 0 0-.976.833 1.82 1.82 0 0 0-.25.95c0 .674.24 1.2.72 1.58s1.143.57 1.99.57c.853 0 1.517-.19 1.99-.57.48-.38.72-.906.72-1.58 0-.353-.087-.67-.26-.95a1.933 1.933 0 0 0-.71-.7 2.107 2.107 0 0 0-.259-.132 2.3 2.3 0 0 0 .579-.428c.307-.32.46-.696.46-1.13 0-.613-.22-1.09-.66-1.43s-1.06-.51-1.86-.51-1.42.17-1.86.51zm2.79 3.9c.207.2.31.457.31.77 0 .327-.11.584-.33.77-.213.187-.517.28-.91.28-.387 0-.69-.093-.91-.28-.22-.186-.33-.443-.33-.77 0-.313.103-.57.31-.77.213-.206.523-.346.93-.42.413.074.723.214.93.42zm-.14-3c.18.14.27.347.27.62 0 .247-.09.457-.27.63-.18.167-.443.287-.79.36-.347-.073-.61-.193-.79-.36a.842.842 0 0 1-.27-.63c0-.273.09-.48.27-.62s.443-.21.79-.21.61.07.79.21z" />
        <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgRank8 as Rank8 };
